import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getLobbyistById } from '../features/lobby/lobbySlice';
import LobbyistClients from '../components/LobbyistClients';
import thumbnail from '../assets/images/thumbnail-img.png';
import MainLoader from '../components/Structures/MainLoader';

const Lobbyist = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, lobbyist } = useSelector((state) => state.lobby);

  useEffect(() => {
    if (id) {
      dispatch(getLobbyistById(id));
    }
  }, [id, dispatch, nav]);

  if (isLoading) return <MainLoader />;

  // Assuming getLobbyistById returns an array with one lobbyist object
  const lobbyistData = lobbyist[0];

  return (
    <>
      <div className="bg-[#F9FAFB] border border-[#E5E7EB] 2xl:p-8 xl:p-6 p-5 mb-[20px]">
        <div className="border-b border-[#E5E7EB] mb-8 pb-8">
          {lobbyistData ? (
            <h2 className="font-playfair text-[28px] text-darkblue font-medium leading-8">
              {lobbyistData.LobbyistTitle} {lobbyistData.LobbyistFirstName} {lobbyistData.LobbyistMiddleName}{' '}
              {lobbyistData.LobbyistLastName}
            </h2>
          ) : (
            <h2 className="font-playfair text-[28px] text-darkblue font-medium leading-8">No Lobbyist Found.</h2>
          )}
        </div>
        <div className="flex lg:flex-row flex-col items-center lg:justify-start justify-center gap-12">
          <div className="block">
            <img src={lobbyistData?.imageUrl || thumbnail} alt="Lobbyist" className="lobbyistImage" />
          </div>
          <div className="block flex-1">
            <h3 className="lg:text-left text-center text-[22px] font-medium font-playfair lg:mb-[40px] mb-5">
              Registered Branches: {lobbyistData?.LobbyistRegisteredBranches}
            </h3>
            <div className="relative">
              {lobbyistData && (
                <>
                  {(lobbyistData.LobbyistAddress1 ||
                    lobbyistData.LobbyistAddress2 ||
                    lobbyistData.LobbyistCity ||
                    lobbyistData.LobbyistState ||
                    lobbyistData.LobbyistZip) && (
                    <h4 className="lg:text-left text-center text-black text-[22px] font-medium font-playfair">
                      Address:{' '}
                      {[
                        lobbyistData.LobbyistAddress1,
                        lobbyistData.LobbyistAddress2,
                        lobbyistData.LobbyistCity,
                        lobbyistData.LobbyistState && lobbyistData.LobbyistZip
                          ? `${lobbyistData.LobbyistState} ${lobbyistData.LobbyistZip}`
                          : lobbyistData.LobbyistState || lobbyistData.LobbyistZip,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                    </h4>
                  )}
                  {lobbyistData.LobbyistPhone && (
                    <p className="lg:text-left text-center text-black text-[22px] font-medium font-playfair">
                      Phone: {lobbyistData.LobbyistPhone}
                    </p>
                  )}
                  <p className="lg:text-left text-center text-black text-[22px] font-medium font-playfair">
                    Clients: {lobbyistData.clients ? lobbyistData.clients.length : 0}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {lobbyistData && lobbyistData.clients && <LobbyistClients clients={lobbyistData.clients} />}
    </>
  );
};

export default Lobbyist;
